import { Header } from '@fhs-legacy/universal-components';

export const StyledHeader = Header.withConfig({
  textAlign: 'center',
});
